import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs";
import { environment } from "src/environments/environment";
import { SearchPaymentProcessorModel } from "../../models/business/search-payment-processor.model";
import { UpdatePaymentProcessorModel } from "../../models/business/update-payment-processor.model";
import { HttpService } from "../common/http-service";


const PAYMENT_API = environment.apiURL + '/api/adm/Payment/';
const PRODUCT_API = environment.apiURL + '/api/adm/Product/';
@Injectable({
    providedIn: 'root'
})

export class PaymentProcessorService {

    //#region Fields

    //#endregion

    //#region Constructor

    constructor(private _httpService: HttpService, private _httpClient: HttpClient) {
    }
    //#endregion

    //#region Public Methods
    getpaymentprocessors(model: SearchPaymentProcessorModel) {
        var url = PAYMENT_API + "getpaymentprocessors";
        return this._httpService.httpPost(url, model)
            .pipe(map(resposne => {
                return resposne;
            }));
    }
    getypaymentprocessorbyid(id: string) {
        var url = PAYMENT_API + "getpaymentprocessor?paymentProcessorId=" + id;;
        return this._httpService.httpGet(url)
            .pipe(map(resposne => {
                return resposne;
            }));
    }
    getallcountrynames() {
        var url = PRODUCT_API + 'getallcountrynames';
        return this._httpService.httpGet(url)
            .pipe(map(resposne => {
                return resposne;
            }));
    }
    updatepaymentprocessor(model: UpdatePaymentProcessorModel){
        var url = PAYMENT_API + "updatepaymentprocessor";
        return this._httpService.httpPost(url, model)
            .pipe(map(resposne => {
                return resposne;
            }));
    }
    getAllProjects() {
        var url = PRODUCT_API + "getallprojectnames";
        return this._httpService.httpGet(url)
          .pipe(map(resposne => {
            return resposne;
          }));
      }
    //#endregion
}